module.exports = __webpack_public_path__ + "img/9.c1f3ec9b.svg";